import React, { useState, useEffect, useReducer } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import ScrollView from 'devextreme-react/scroll-view';
import { useParams } from 'react-router-dom';
import * as action from '../../../actions/kaizen';
import kaizenReducer from '../../../reducers/kaizen';

const initialState = { siteFocalInfo: null, allUsers: [] }
const initialDetails = { ownerDetails: null, siteLeaderDetails: null, alternateEidDetails: null }
const SiteFocalInformation = props => {
    const { category, site } = useParams()
    const [state, dispatch] = useReducer(kaizenReducer, initialState)
    const { siteFocalInfo, allUsers } = state
    const [details, setDetails] = useState({ ...initialDetails })
    const [animate, setAnimate] = useState('');

    useEffect(() => {
        action.fetchKaizenSiteFocalInfo(dispatch, site);
        action.fetchKaizenAllUsers(dispatch);
    }, [])

    useEffect(() => {
        if (siteFocalInfo && allUsers.length > 0) {
            let ownerDetails = allUsers.filter(ele => ele.employeeId === siteFocalInfo[0].ownerEid.toUpperCase())?.[0]
            let siteLeaderDetails = allUsers.filter(ele => ele.employeeId === siteFocalInfo[0].siteLeader.toUpperCase())?.[0]
            let alternateEid1Details = allUsers.filter(ele => ele.employeeId === siteFocalInfo[0].alternateEid1?.toUpperCase())?.[0]
            let alternateEid2Details = allUsers.filter(ele => ele.employeeId === siteFocalInfo[0].alternateEid2?.toUpperCase())?.[0]
            let alternateEid3Details = allUsers.filter(ele => ele.employeeId === siteFocalInfo[0].alternateEid3?.toUpperCase())?.[0]
            let alternateEid4Details = allUsers.filter(ele => ele.employeeId === siteFocalInfo[0].alternateEid4?.toUpperCase())?.[0]
            setDetails({ ownerDetails, siteLeaderDetails, alternateEidDetails: [alternateEid1Details, alternateEid2Details, alternateEid3Details, alternateEid4Details] })
        }
    }, [allUsers, siteFocalInfo])

    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);

    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    return (
        <>
            <Header showPinBtn={false} site={[]} />

            <section className="page-content">
                <div className="site-view tier-wrap admin-console-wrapper">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className="icon icon-corporate"></span>
                            <ul>
                                <li><Link to={`/`}>Home</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`}>Kaizen</Link></li>
                                <li>Site Focal Information</li>
                            </ul>
                        </div>

                        <div className="raiseci-section">
                            <div className="page-heading">
                                <h2>Site Focal Information</h2>
                            </div>
                        </div>

                        <ScrollView {...scrollConfig} style={{ height: "80%" }}>
                            <div className="sfinfo-section">
                                <div className="sfinfo-sub-section">
                                    {details.ownerDetails
                                        &&
                                        <div className="sfinfo-card sfinfo-card-lg">
                                            <h3>Kaizen Owner</h3>
                                            <i className="dx-icon-user" style={{ fontSize: "5rem" }}></i>
                                            <h4>{details.ownerDetails.employeeName}</h4>
                                            <div className="sfinfo-email">
                                                <i className="dx-icon-email" style={{ fontSize: "1.25rem" }}></i>
                                                <div className="dx-label">{details.ownerDetails.emailId.toLowerCase()}</div>
                                            </div>
                                        </div>
                                    }
                                    {details.siteLeaderDetails
                                        &&
                                        <div className="sfinfo-card sfinfo-card-lg">
                                            <h3>Site Leader</h3>
                                            <i className="dx-icon-user" style={{ fontSize: "5rem" }}></i>
                                            <h4>{details.siteLeaderDetails.employeeName}</h4>
                                            <div className="sfinfo-email">
                                                <i className="dx-icon-email" style={{ fontSize: "1.25rem" }}></i>
                                                <div className="dx-label">{details.siteLeaderDetails.emailId.toLowerCase()}</div>
                                            </div>
                                        </div>
                                    }

                                </div>
                                <br />
                                <div className="sfinfo-sub-section">
                                    {details.alternateEidDetails
                                        &&
                                        details.alternateEidDetails.filter(ele => ele).map((ele, id) =>
                                            <div className="sfinfo-card sfinfo-card-sm" key={id}>
                                                <h3>Alternative {id + 1}</h3>
                                                <i className="dx-icon-user" style={{ fontSize: "4rem" }}></i>
                                                <h4>{ele.employeeName}</h4>
                                                <div className="sfinfo-email">
                                                    <i className="dx-icon-email" style={{ fontSize: "1.25rem" }}></i>
                                                    <div className="dx-label">{ele.emailId.toLowerCase()}</div>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                        </ScrollView>
                    </div>
                </div>
            </section>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>
        </>
    )
};
export default SiteFocalInformation
